import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  getCurrentDate,
  getCurrentMonthFirstDate,
  minutesToHHMM,
  timeToSeconds,
} from "../../Utilitie";
import DownloadExcel from "../../Extra/DownloadExcel";
import Loading from "../../Extra/Loading";

const AgreedAndGivenBlock = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [fetchData1, setFetchData1] = useState([]);
  const tableRef = useRef();
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getblockcompileddataForENG?start=${startDate}&end=${endDate}`
      );

      if (response.data.status === "ok") {
        setFetchData1(response.data.current);
      } else {
        setFetchData1([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchedData();
  }, []);

  const availableDirections = fetchData1.map((d) => d.Direction);
  const [selectedDirections, setSelectedDirections] = useState(new Set());

  // Set selected directions when data is fetched
  useEffect(() => {
    const available = fetchData1.map((d) => d.Direction);
    setSelectedDirections(new Set(available));
  }, [fetchData1]);

  const toggleDirection = (direction) => {
    setSelectedDirections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(direction)) {
        newSet.delete(direction);
      } else {
        newSet.add(direction);
      }
      return newSet;
    });
  };

  const uniqueDates = new Set();
  const columns = [];
  const flatData = {};

  fetchData1.forEach((directionGroup) => {
    const { Direction, children: sections } = directionGroup;

    if (!selectedDirections.has(Direction)) return;

    sections.forEach((section) => {
      const { section: sectionName, data: demandData } = section;
      const key = `${sectionName}-${Direction}`;

      let cumgiven = 0;
      let cumAgreed = 0;

      demandData
        .sort((a, b) => new Date(a.reportDate) - new Date(b.reportDate)) // sort by date
        .forEach(({ reportDate, Availed_tot, Agreed_Demand_tot }) => {
          uniqueDates.add(reportDate);

          const given = parseFloat(Availed_tot) || 0;
          const agreed = parseFloat(Agreed_Demand_tot) || 0;
          const percentage = agreed
            ? ((given / agreed) * 100).toFixed(2)
            : "0.00";

          if (!flatData[reportDate]) flatData[reportDate] = {};
          flatData[reportDate][`${key}-Given`] = given;
          flatData[reportDate][`${key}-Agreed`] = agreed;
          flatData[reportDate][`${key}-Percentage`] = percentage;

          cumgiven += given;
          cumAgreed += agreed;
          const cumPercent = cumAgreed
            ? ((cumgiven / cumAgreed) * 100).toFixed(2)
            : "0.00";

          flatData[reportDate][`${key}-Cumulative`] = cumPercent;

          if (!columns.includes(`${key}-Given`)) columns.push(`${key}-Given`);
          if (!columns.includes(`${key}-Agreed`)) columns.push(`${key}-Agreed`);
          if (!columns.includes(`${key}-Percentage`))
            columns.push(`${key}-Percentage`);
          if (!columns.includes(`${key}-Cumulative`))
            columns.push(`${key}-Cumulative`);
        });
    });
  });

  const sortedDates = Array.from(uniqueDates).sort();

  return (
    <div>
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
        <h5 className="">Agreed and given block section wise </h5>
        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              // className="form-control"
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={fetchedData}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <strong>Select Directions:</strong>{" "}
        {availableDirections.map((dir) => (
          <label key={dir} style={{ marginRight: "15px" }}>
            <input
              type="checkbox"
              checked={selectedDirections.has(dir)}
              onChange={() => toggleDirection(dir)}
            />
            {dir}
          </label>
        ))}
      </div>

      <div className="table-responsive position-relative">
        <table
          ref={tableRef}
          className=" table table-bordered table-striped mb-4 papaDiv "
          style={{ fontSize: "12px" }}
        >
          <thead className="table-dark align-middle">
            <tr>
              <th className="sticky-col" rowSpan={3}>
                Date
              </th>
              {Array.from(selectedDirections).map((dir) => {
                const sections =
                  fetchData1.find((d) => d.Direction === dir)?.children || [];
                const sectionCount = sections.length;
                return (
                  <th key={dir} colSpan={sectionCount * 4}>
                    {dir}
                  </th>
                );
              })}
            </tr>

            <tr>
              {Array.from(selectedDirections).flatMap((dir) => {
                const sections =
                  fetchData1.find((d) => d.Direction === dir)?.children || [];
                return sections.map((section) => (
                  <th key={`${dir}-${section.section}`} colSpan={4}>
                    {section.section}
                  </th>
                ));
              })}
            </tr>

            <tr>
              {Array.from(selectedDirections).flatMap((dir) => {
                const sections =
                  fetchData1.find((d) => d.Direction === dir)?.children || [];
                return sections.flatMap(() => (
                  <React.Fragment>
                    <th>Agreed</th>

                    <th>given</th>
                    <th className="text-wrap">% of block given</th>
                    <th className="text-wrap">Cumulative %</th>
                  </React.Fragment>
                ));
              })}
            </tr>
          </thead>

          <tbody>
            {sortedDates.map((date) => (
              <tr key={date}>
                <td
                  className="sticky-col"
                  style={{
                    background: "rgba(173, 172, 172, 1)",
                    fontWeight: "bold",
                  }}
                >
                  {date}
                </td>
                {Array.from(selectedDirections).flatMap((dir) => {
                  const sections =
                    fetchData1.find((d) => d.Direction === dir)?.children || [];
                  return sections.flatMap((section) => {
                    const key = `${section.section}-${dir}`;
                    return (
                      <React.Fragment>
                        <td>
                          {minutesToHHMM(
                            (flatData[date]?.[`${key}-Agreed`] ?? 0) / 60,
                            true
                          )}
                        </td>
                        <td>
                          {minutesToHHMM(
                            (flatData[date]?.[`${key}-Given`] ?? 0) / 60,
                            true
                          )}
                        </td>

                        <td>{flatData[date]?.[`${key}-Percentage`] ?? "-"}</td>
                        <td>{flatData[date]?.[`${key}-Cumulative`] ?? "-"}</td>
                      </React.Fragment>
                    );
                  });
                })}
              </tr>
            ))}
            <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
              <td
                className="sticky-col "
                style={{
                  background: "rgba(173, 172, 172, 1)",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                Total
              </td>
              {Array.from(selectedDirections).flatMap((dir) => {
                const sections =
                  fetchData1.find((d) => d.Direction === dir)?.children || [];
                return sections.flatMap((section) => {
                  const key = `${section.section}-${dir}`;
                  let totalAgreed = 0;
                  let totalGiven = 0;

                  sortedDates.forEach((date) => {
                    totalAgreed += flatData[date]?.[`${key}-Agreed`] || 0;
                    totalGiven += flatData[date]?.[`${key}-Given`] || 0;
                  });

                  return (
                    <React.Fragment>
                      <td>{minutesToHHMM(totalAgreed / 60, true)}</td>
                      <td>{minutesToHHMM(totalGiven / 60, true)}</td>
                      <td>-</td>
                      <td>-</td>
                    </React.Fragment>
                  );
                });
              })}
            </tr>
          </tbody>
        </table>
        {loading && <Loading />}
      </div>
      <div className="m-1">
        {!fetchData1 ? (
          <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
        ) : null}
        <DownloadExcel
          tableRef={tableRef}
          fileName={`Agreed and Given block (Eng) - ${startDate}-${endDate}`}
        />
      </div>
    </div>
  );
};

export default AgreedAndGivenBlock;
